import { render } from "./Organisator.vue?vue&type=template&id=6ed4f2a4&scoped=true"
import script from "./Organisator.vue?vue&type=script&lang=js"
export * from "./Organisator.vue?vue&type=script&lang=js"

import "./Organisator.vue?vue&type=style&index=0&id=6ed4f2a4&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed4f2a4"]])

export default __exports__